<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <large-base-card>
    <div
      class="d-flex flex-wrap align-center"
      @click="$router.push({name:'cashBook'})"
    >
      <div>
        <div class="text-h4 font-weight-bold">
          {{ $t('cashBook') }}
        </div>
        <div class="text-body-2 text-subtitle-1">
          {{ $t('CurrentSaldoWithoutTodaysSales') }}
        </div>
      </div>
      <v-spacer />
      <div
        class="d-flex align-center"
        style="height: 48px;"
      >
        <v-icon>mdi-book</v-icon>
      </div>

      <v-card
        class="pt-4 overflow-hidden overflow-y-auto"
        elevation="0"
        style="height: 400px; width: 100%;"
      >
        <template v-if="getNonOperatingIncome(billData).length > 0">
          <template
            v-for="item in getNonOperatingIncome(billData)"
          >
            <div
              :key="item.key"
              class="d-flex align-end py-2"
            >
              <div class="ml-0 mr-auto d-flex flex-wrap">
                <div style="width: 100%">
                  {{ item.cashAccountNote }}
                </div>
                <div class="text-body-1 font-weight-light">
                  {{ item.orderId }}@{{ formatDate(item.updateTimestamp) }}
                </div>
              </div>
              <div class="ml-auto mr-0">
                <div
                  :style="(item.payLogAmount >= 0)?{color:'#4CAF50'}:{color:'#1b5e20'}"
                  class="text-h3 font-weight-thin"
                >
                  <template
                    v-if="item.payLogAmount >= 0"
                  >
                    <div class="d-flex align-center">
                      <div class="pt-1 text-h4">
                        +
                      </div>
                      <div>{{ item.payLogAmount | priceDisplay }}</div>
                    </div>
                  </template>
                  <template v-else>
                    {{ item.payLogAmount | priceDisplay }}
                  </template>
                </div>
              </div>
            </div>
          </template>
        </template>
        <template v-else>
          <v-card
            class="d-flex justify-center align-center"
            elevation="0"
            height="100%"
          >
            <div>
              <div class="d-flex align-center justify-center flex-wrap">
                <div class="mt-2">
                  <v-icon
                    class="order-0"
                    color="#eee"
                    size="125px"
                  >
                    mdi-file-document-alert
                  </v-icon>
                </div>
                <div
                  :style="$vuetify.breakpoint.smAndUp ? $vuetify.breakpoint.mdAndUp ? 'width: 80%' : 'width: 70%' : 'width: 90%'"
                  class="mt-2"
                >
                  <div>{{ $t('noDataNow') }}</div>
                </div>
              </div>
            </div>
          </v-card>
        </template>
      </v-card>
    </div>
  </large-base-card>
</template>

<script>
import LargeBaseCard from '@/views/widget/commonDecoration/LargeBaseCard.vue'
import CashBook from '@/model/dataLayer/api/bills/cashbook/CashBook'
import dayjs from 'dayjs'
import { getAllDeviceIdCashBookList } from '@/model/dataLayer/service/MultipleStores'

export default {
  name: 'CashbookInfo',
  components: {
    LargeBaseCard
  },
  props: {
    info: {},
    date: {}
  },
  data () {
    return {
      billData: [],
      model: CashBook,
      loading: false
    }
  },
  computed: {
    filter () {
      return {
        dateFilter: this.date
      }
    }
  },
  watch: {
    info: {
      immediate: true,
      deep: true,
      handler (val) {
        this.initialize()
      }
    },
    date: {
      handler: function (val) {
        this.initialize()
      }
    }
  },
  async mounted () {
    await this.initialize()
  },
  methods: {
    getNonOperatingIncome (income) {
      return Object.values(income)
        .filter(x => x.cashAccountNote.toLowerCase() !== 'umsatz' && x.cashAccountNote.toLowerCase() !== 'trinkgeld')
    },
    formatDate (date) {
      return dayjs(date).format('HH:mm:ss')
    },
    async initialize () {
      this.loading = true
      this.billData = (await Promise.allSettled(this.info?.url
        ?.map(it => getAllDeviceIdCashBookList(it, this.date)) ?? [])).map(it => it.value).flat()
      this.loading = false
    }
  }
}
</script>
